/* ------------------------------------------------------------------
   Free gift with purchase
   ------------------------------------------------------------------
   When the cart contains one of the TRIGGER_SKUS below, the gift
   product picked in Theme settings > Free gift is added to the cart
   automatically. It's removed again as soon as none of the trigger
   SKUs remain.

   - No gift product picked in theme settings -> this whole feature
     does nothing (KROWN.settings.free_gift_variant_id is null).
   - The $0.00 price is handled by a Buy X Get Y automatic discount
     already set up in Shopify admin. This script only makes sure
     the item is in the cart; it never touches price.
   - The auto-added line is tagged with a hidden property so it
     never gets merged with (or accidentally removed alongside) a
     unit of the same product a customer adds on purpose.

   This watches #AjaxCartForm for changes instead of hooking every
   add-to-cart button, so it keeps working no matter which part of
   the theme triggered the cart update (product page, quick add,
   cart drawer, cart page).
------------------------------------------------------------------ */

(() => {

  // Edit this list to change which SKUs trigger the free gift.
/* ==========================================================================
   SEASONS — free power adapter: add Helio Home + Chroma Home
   Live theme: 09/17 TS  →  assets/free-gift.js  →  lines 27–37

   HOW TO APPLY
   1. Online Store → Themes → 09/17 TS → ⋯ → Edit code
   2. assets/free-gift.js
   3. Select lines 27 to 37 — from "const TRIGGER_SKUS = [" down to and
      including the "];" — and paste the block below over them.
   4. Hit Compare first if it warns about a conflict, then Save.

   The only change is the two new lines at the bottom of the list. The
   comments are new too; they're there so the next colourway is obvious.
   ========================================================================== */

  const TRIGGER_SKUS = [
    'SSAW-002ALM-2025',  // Aero SM
    'SSAW-002BH',        // Aero SM
    'SSAW-002AWH-2025',  // Aero SM
    'SSAW-002GY',        // Aero SM
    'SSAW-002AMG-2025',  // Aero SM
    'SSAW-001ALM-2025',  // Soni SM
    'SSAW-001ABL-2025',  // Soni SM
    'SSAW-001AGY-2025',  // Soni SM
    'SSAW-001AWH-2025',  // Soni SM
    'SSAW-003DFG',       // Helio Home — Ivory
    'SSAW-003DSG'        // Chroma Home
  ];

  const GIFT_PROPERTY_KEY = '_free_gift';
  const GIFT_PROPERTY_VALUE = 'true';

  let isSyncing = false;
  let debounceTimer = null;

  const getGiftVariantId = () => {
    const id = window.KROWN && KROWN.settings && KROWN.settings.free_gift_variant_id;
    return id ? String(id) : '';
  };

  const cartHasTrigger = cart => cart.items.some(item => item.sku && TRIGGER_SKUS.includes(item.sku));

  const findGiftLine = (cart, variantId) => cart.items.find(item =>
    String(item.variant_id) === variantId &&
    item.properties &&
    item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE
  );

  const refreshCartUI = () => fetch('?section_id=cart-helper')
    .then(response => response.text())
    .then(text => {
      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

      const cartItems = document.getElementById('AjaxCartForm');
      if (cartItems) {
        cartItems.innerHTML = cartFormInnerHTML;
        if (typeof cartItems.ajaxifyCartItems === 'function') {
          cartItems.ajaxifyCartItems();
        }
      }

      const cartSubtotal = document.getElementById('AjaxCartSubtotal');
      if (cartSubtotal) {
        cartSubtotal.innerHTML = cartSubtotalInnerHTML;
      }

      if (window.preloadImages) window.preloadImages(cartItems);

      const headerCount = document.querySelector('[data-header-cart-count]');
      const cartCount = cartItems && cartItems.querySelector('[data-cart-count]');
      if (headerCount && cartCount) {
        headerCount.textContent = cartCount.textContent;
      }
    });

  const addGift = variantId => fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: { [GIFT_PROPERTY_KEY]: GIFT_PROPERTY_VALUE }
      }]
    })
  });

  const removeGift = lineKey => fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  });

  const syncFreeGift = () => {
    const giftVariantId = getGiftVariantId();
    if (!giftVariantId || isSyncing) return;

    isSyncing = true;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const giftLine = findGiftLine(cart, giftVariantId);
        const triggerPresent = cartHasTrigger(cart);

        if (triggerPresent && !giftLine) {
          return addGift(giftVariantId).then(refreshCartUI);
        }
        if (!triggerPresent && giftLine) {
          return removeGift(giftLine.key).then(refreshCartUI);
        }
      })
      .catch(e => {
        console.log('Free gift sync error:', e);
      })
      .finally(() => {
        isSyncing = false;
      });
  };

  const scheduleSync = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFreeGift, 150);
  };

  const watchCartForm = () => {
    const cartFormEl = document.getElementById('AjaxCartForm');
    if (!cartFormEl) return;

    new MutationObserver(() => {
      if (!isSyncing) scheduleSync();
    }).observe(cartFormEl, { childList: true });
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (!getGiftVariantId()) return; // no gift product chosen in theme settings
    watchCartForm();
    syncFreeGift();
  });

})();
